// Silo v2 — ISiloLens (subset)
//
// Returns deposit / borrow APR for a silo at 1e18 = 100%/yr scale.
// All values are forward-looking instantaneous APR computed from the IRM.
//
// NOTE: this is the v2 SiloLens (silo-contracts-v2). The page at
// `devdocs.silo.finance/smart-contracts-overview/silolens` documents the v1
// lens (`depositAPY`, etc.) — do NOT use those signatures.
export const SiloLensAbi = [
  {
    type: 'function',
    name: 'getDepositAPR',
    stateMutability: 'view',
    inputs: [{ name: '_silo', type: 'address' }],
    outputs: [{ name: 'depositAPR', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'getBorrowAPR',
    stateMutability: 'view',
    inputs: [{ name: '_silo', type: 'address' }],
    outputs: [{ name: 'borrowAPR', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'getUtilization',
    stateMutability: 'view',
    inputs: [{ name: '_silo', type: 'address' }],
    outputs: [{ name: 'utilization', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'getRawLiquidity',
    stateMutability: 'view',
    inputs: [{ name: '_silo', type: 'address' }],
    outputs: [{ name: 'liquidity', type: 'uint256' }],
  },
] as const
